import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos - dados ficam "frescos"
      gcTime: 10 * 60 * 1000, // 10 minutos - garbage collection (era cacheTime)
      retry: 1, // Tentar 1 vez em caso de erro
      refetchOnWindowFocus: false, // Não refetch ao focar janela (pode ativar depois)
      refetchOnReconnect: true, // Refetch quando reconectar
      networkMode: 'online', // Só fazer requisições online
    },
    mutations: {
      retry: 0, // Não retentar mutations
    },
  },
});





